import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

export default function PasswordField({
  value,
  onChange,
  placeholder = '',
  autoFocus = false,
  disabled = false,
  autoComplete = 'current-password',
  name,
  id,
  className = '',
}) {
  const [visible, setVisible] = useState(false)

  return (
    <div className={`password-input-wrap ${className}`.trim()}>
      <input
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        disabled={disabled}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        className="password-visibility-toggle"
        aria-label={visible ? 'Password visible. Click to hide password' : 'Password hidden. Click to show password'}
        onClick={() => setVisible((v) => !v)}
      >
        {visible ? <Eye size={16} /> : <EyeOff size={16} />}
      </button>
    </div>
  )
}
